import { useEffect, useRef, useState, useCallback } from "react";
import { api } from "@/lib/api";

export function useSyncedState(kind, initial) {
  const [val, setVal] = useState(() => (typeof initial === "function" ? initial() : initial));
  const [status, setStatus] = useState("loading");
  const loaded = useRef(false);
  const t = useRef(null);

  useEffect(() => {
    api.get(`/sync/${kind}`).then((r) => {
      if (r.data.data != null) setVal(r.data.data);
      setStatus("saved");
    }).catch(() => setStatus("error")).finally(() => { loaded.current = true; });
  }, [kind]);

  useEffect(() => {
    if (!loaded.current) return;
    setStatus("saving");
    clearTimeout(t.current);
    t.current = setTimeout(() => api.put(`/sync/${kind}`, { data: val }).then(() => setStatus("saved")).catch(() => setStatus("error")), 1000);
    return () => clearTimeout(t.current);
  }, [val, kind]);

  const set = useCallback((v) => setVal(v), []);
  return [val, set, status];
}

export const worstStatus = (...s) => ["error", "loading", "saving", "saved"].find((x) => s.includes(x)) || "idle";
